import React, { useEffect, useState } from "react";
import { ACTIONS } from "../../../screens/support/jobChangeMenu";
import SearchDropdown from "../../input/SearchDropdown";
import { getOtherRefSearchDropdown } from "../../../api/keyvalue";
import Button from "../../input/Button";
import Input from "../../input/Input";
import DateTimePickerInput from "../../input/DateTimePickerInput";
import { formatFromJsonDate } from "../../../dateConfig";
import { vehicleAssignmentSearch } from "../../../api/jobApi";
import { useSelector } from "react-redux";
import useUserCompany from "../../../hooks/useUserCompany";
import { submitJobModification } from "../../../api/jobModificationApi";
import { toast } from "react-toastify";
import RequestOther from "../../transaction/RequestCreation/RequestOther";
import JobOtherChange from "./JobOtherChange";
import { Checkbox } from "semantic-ui-react";
import { error } from "jquery";

const JobChange = ({
  actionType,
  closeModal,
  editMode,
  initialData,
  isOpen,
}) => {
  useEffect(() => {}, [initialData, editMode, actionType]);
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [jobModification, setJobModification] = useState({
    jobId: "",
    requestId: "",
    billingCustomerId: "",
    invoicingCustomerId: "",
    creatorRemark: "",
    operationRemark: "",
    plant: "",
    transporter: "",
    vehicle: "",
    driver: "",
    helper: "",
    vehicleType: "",
    arrivalTime: null,
    deliveryCutoffDate: null,
    modificationRemark: "",
    customer: "",
    kmActual: "",
    chargeableKm: "",
  });
  const [otherRequests, setOtherRequests] = useState([]);
  const [removeCreatorRemark, setRemoveCreatorRemark] = useState(false);

  useEffect(() => {
    console.log("jobModification state:", jobModification);
  }, [jobModification]);

  const [currentErrors, setCurrentErrors] = useState({});
  const [vehicleReset, setVehicleReset] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const user = useSelector((state) => state.user);
  const company = useUserCompany();

  // useEffect(() => {
  //   if (initialData && isOpen) {
  //     if (Array.isArray(initialData)) {
  //       setJobModification({
  //         jobId: "",
  //         requestId: "",
  //         billingCustomerId: "",
  //         invoicingCustomerId: "",
  //         creatorRemark: "",
  //         operationRemark: "",
  //         plant: "",
  //         transporter: "",
  //         vehicle: "",
  //         driver: "",
  //         helper: "",
  //         vehicleType: "",
  //         arrivalTime: null,
  //         deliveryCutoffDate: null,
  //         modificationRemark: "",
  //         customer: "",
  //       });
  //       setSearchFieldReset(true);
  //       setTimeout(() => setSearchFieldReset(false), 0);
  //     } else {
  //       setJobModification({
  //         jobId: initialData.jobId || "",
  //         requestId: initialData.requestId || "",
  //         billingCustomerId: initialData.billingCustomerId || "",
  //         invoicingCustomerId: initialData.invoicingCustomerId || "",
  //         creatorRemark: initialData.creatorRemark || "",
  //         operationRemark: initialData.operationRemark || "",
  //         plant: initialData.plant || "",
  //         transporter: initialData.transporter || "",
  //         vehicle: initialData.vehicle || "",
  //         driver: initialData.driver || "",
  //         helper: initialData.helper || "",
  //         vehicleType: initialData.vehicleType || "",
  //         arrivalTime: initialData.arrivalTime || null,
  //         deliveryCutoffDate: initialData.deliveryCutoffDate || null,
  //         modificationRemark: "",
  //         customer: initialData.customer || null,
  //       });
  //     }

  //     setIsDataLoaded(true);
  //   }
  // }, [initialData, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setJobModification({
        jobId: "",
        requestId: "",
        billingCustomerId: "",
        invoicingCustomerId: "",
        creatorRemark: "",
        operationRemark: "",
        plant: "",
        transporter: "",
        vehicle: "",
        driver: "",
        helper: "",
        vehicleType: "",
        arrivalTime: null,
        deliveryCutoffDate: null,
        modificationRemark: "",
        chargeableKm: "",
        kmActual: "",
      });
      setOtherRequests([]);
      setCurrentErrors({});
      setIsDataLoaded(false);
      setSearchFieldReset(false);
      setTimeout(() => setSearchFieldReset(false), 0);
      return;
    }
    if (!initialData) return;
    if (Array.isArray(initialData)) {
      setJobModification({
        jobId: "",
        requestId: "",
        billingCustomerId: "",
        invoicingCustomerId: "",
        creatorRemark: "",
        operationRemark: "",
        plant: "",
        transporter: "",
        vehicle: "",
        driver: "",
        helper: "",
        vehicleType: "",
        arrivalTime: null,
        deliveryCutoffDate: null,
        modificationRemark: "",
        customer: "",
        chargeableKm: "",
        kmActual: "",
      });
      setSearchFieldReset(true);
      setTimeout(() => setSearchFieldReset(false), 0);
    } else {
      setSearchFieldReset(false);
      setJobModification({
        jobId: initialData.jobId || "",
        requestId: initialData.requestId || "",
        billingCustomerId: initialData.billingCustomerId || "",
        invoicingCustomerId: initialData.invoicingCustomerId || "",
        creatorRemark: initialData.creatorRemark || "",
        operationRemark: initialData.operationRemark || "",
        plant: initialData.plant || "",
        transporter: initialData.transporter || "",
        vehicle: initialData.vehicle || "",
        driver: initialData.driver || "",
        helper: initialData.helper || "",
        vehicleType: initialData.vehicleType || "",
        arrivalTime: initialData.arrivalTime || null,
        deliveryCutoffDate: initialData.deliveryCutoffDate || null,
        modificationRemark: "",
        customer: initialData.customer || null,
        kmActual: initialData.kmActual || null,
        chargeableKm: initialData.chargeableKm || null,
      });
    }

    setIsDataLoaded(true);
  }, [isOpen, isOpen]);
  const [commitment, setCommitment] = useState(2);
  const [exactCbm, setExactCbm] = useState(2);

  const resetError = (field) => {
    setCurrentErrors((prevState) => {
      const { [field]: _, ...rest } = prevState;
      return rest;
    });
  };
  const resetVehicleSection = () => {
    setJobModification((prevState) => ({
      ...prevState,
      vehicle: null,
      driver: null,
      helper: null,
    }));

    setVehicleReset(true);

    setTimeout(() => setVehicleReset(false), 0);
  };

  const resetAllStates = () => {
    setJobModification({
      jobId: "",
      requestId: "",
      billingCustomerId: "",
      invoicingCustomerId: "",
      creatorRemark: "",
      operationRemark: "",
      plant: "",
      transporter: "",
      vehicle: "",
      driver: "",
      helper: "",
      vehicleType: "",
      arrivalTime: null,
      deliveryCutoffDate: null,
      modificationRemark: "",
      customer: "",
      kmActual: "",
      chargeableKm: "",
    });

    setOtherRequests([]);
    setCurrentErrors({});
    setIsDataLoaded(false);
    setSearchFieldReset(true);
    setTimeout(() => setSearchFieldReset(false), 0);
  };

  // useEffect(() => {
  //   if (!isOpen) {
  //     resetAllStates();
  //   }
  // }, [isOpen]);

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    const errors = {};

    if (
      actionType === ACTIONS.BILLING_CUSTOMER &&
      !jobModification.billingCustomerId
    ) {
      errors.billingCustomerId = "Billing customer is required";
    }

    if (
      actionType === ACTIONS.INVOICING_CUSTOMER &&
      !jobModification.invoicingCustomerId
    ) {
      errors.invoicingCustomerId = "Invoicing customer is required";
    }

    if (actionType === ACTIONS.CREATOR_REMARK) {
      if (removeCreatorRemark && !jobModification.creatorRemark?.trim()) {
        errors.creatorRemark = "There is no existing creator remark to remove";
      } else if (
        !removeCreatorRemark &&
        !jobModification.creatorRemark?.trim()
      ) {
        errors.creatorRemark =
          "Please enter a creator remark or select 'Remove existing creator remark'";
      }
    }

    if (
      actionType === ACTIONS.OPERATION_REMARK &&
      !jobModification.operationRemark?.trim()
    ) {
      errors.operationRemark = "Operation remark is required";
    }

    if (actionType === ACTIONS.PLANT_CHANGE && !jobModification.plant) {
      errors.plant = "Plant is required";
    }

    if (actionType === ACTIONS.VEHICLE_CHANGES) {
      if (
        !jobModification.vehicle &&
        !jobModification.transporter &&
        !jobModification.driver &&
        !jobModification.helper &&
        !jobModification.vehicleType
      ) {
        errors.vehicleChanges = "At least one field must be selected";
      }
    }

    if (
      actionType === ACTIONS.REQUEST_ARRIVAL_TIME &&
      !jobModification.arrivalTime
    ) {
      errors.arrivalTime = "Arrival time is required";
    }

    if (
      actionType === ACTIONS.DELIVERY_CUTOFF_DATE &&
      !jobModification.deliveryCutoffDate
    ) {
      errors.deliveryCutoffDate = "Delivery cutoff date is required";
    }
    if (actionType === ACTIONS.OTHER_REQUEST) {
      const modifiedOthers = otherRequests.filter((o) => o.action !== null);
      if (modifiedOthers.length === 0) {
        errors.otherRequests = "No changes made to other requests";
      }
    }
    if (actionType === ACTIONS.KM_CHANGE) {
      if (!jobModification.chargeableKm && !jobModification.kmActual) {
        errors.kmChange =
          "At least one field (Chargeable Km or Cargo In Hand) is required";
      }
    }

    if (Object.keys(errors).length > 0) {
      setCurrentErrors(errors);
      return;
    }
    setShowConfirmation(true);
  };
  const handleConfirmedSubmit = async () => {
    setShowConfirmation(false);

    let selectedData = [];

    if (Array.isArray(initialData)) {
      selectedData = initialData.map((row) => ({
        jobId: row.jobId,
        requestId: row.requestId,
      }));
    } else if (initialData?.jobId) {
      selectedData = [
        {
          jobId: initialData.jobId,
          requestId: initialData.requestId,
        },
      ];
    }

    const payload = {
      items: selectedData,
      modificationRemark: jobModification.modificationRemark,
    };

    switch (actionType) {
      case ACTIONS.BILLING_CUSTOMER:
        payload.billingCustomerId = jobModification.billingCustomerId;
        break;
      case ACTIONS.INVOICING_CUSTOMER:
        payload.invoicingCustomerId = jobModification.invoicingCustomerId;
        break;
      case ACTIONS.CREATOR_REMARK:
        if (removeCreatorRemark) {
          payload.removeCreatorRemark = true;
        } else {
          payload.creatorRemark = jobModification.creatorRemark;
        }
        break;
      case ACTIONS.OPERATION_REMARK:
        payload.operationRemark = jobModification.operationRemark;
        break;
      case ACTIONS.PLANT_CHANGE:
        payload.plant = jobModification.plant;
        break;
      case ACTIONS.VEHICLE_CHANGES:
        if (jobModification.vehicle) payload.vehicle = jobModification.vehicle;
        if (jobModification.transporter)
          payload.transporter = jobModification.transporter;
        if (jobModification.driver) payload.driver = jobModification.driver;
        if (jobModification.helper) payload.helper = jobModification.helper;
        if (jobModification.vehicleType)
          payload.vehicleType = jobModification.vehicleType;
        break;
      case ACTIONS.REQUEST_ARRIVAL_TIME:
        payload.arrivalTime = jobModification.arrivalTime;
        break;
      case ACTIONS.DELIVERY_CUTOFF_DATE:
        payload.deliveryCutoffDate = jobModification.deliveryCutoffDate;
        break;
      case ACTIONS.KM_CHANGE:
        if (jobModification.chargeableKm)
          payload.chargeableKm = jobModification.chargeableKm;
        if (jobModification.kmActual)
          payload.kmActual = jobModification.kmActual;
        break;
      case ACTIONS.OTHER_REQUEST:
        const modifiedOthers = otherRequests.filter((o) => o.action !== null);
        payload.otherRequests = modifiedOthers.map((other) => ({
          rotId: other.rotId,
          rotChargeType: other.rotChargeType,
          rotValue: other.rotValue,
          rotRemarks: other.rotRemarks,
          rotStatus: other.rotStatus,
          action: other.action,
        }));
        break;
      default:
        break;
    }

    try {
      setIsSubmitting(true);

      const response = await submitJobModification(
        payload,
        user.username,
        company.comId,
      );

      toast.success("Job modification updated successfully", {
        autoClose: 1000,
        containerId: "Modal",
      });

      setTimeout(() => {
        closeModal();
      }, 1000);
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "Failed to update job modification. Please try again.",
        {
          autoClose: 3000,
          containerId: "Modal",
        },
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <h4 className="ui dividing headder">Job Modification</h4>
          <div className="ui segment">
            {actionType === ACTIONS.BILLING_CUSTOMER && (
              <div className="field">
                <SearchDropdown
                  editMode={editMode}
                  required={true}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Billing customer",
                  }}
                  label="Billing Customer"
                  field="req_billing_customer"
                  value={jobModification.billingCustomerId}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: jobModification.billingCustomerId?.toString(),
                  }}
                  onResultSelect={(data) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      billingCustomerId: data,
                    }));
                  }}
                  onChange={(value) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      billingCustomerId: value,
                    }));
                    resetError("billingCustomerId");
                  }}
                  onClear={() => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      billingCustomerId: null,
                    }));
                  }}
                  error={currentErrors.billingCustomerId}
                  resetError={() => resetError("billingCustomerId")}
                />
              </div>
            )}
            {actionType === ACTIONS.INVOICING_CUSTOMER && (
              <div className="field">
                <SearchDropdown
                  required={true}
                  editMode={editMode}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Invoicee Customer",
                  }}
                  label="Invoicing Customer"
                  value={jobModification.invoicingCustomerId}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: jobModification.invoicingCustomerId?.toString(),
                  }}
                  onChange={(value) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      invoicingCustomerId: value,
                    }));
                    resetError("invoicingCustomerId");
                  }}
                  onClear={() => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      invoicingCustomerId: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      invoicingCustomerId: data,
                    }));
                  }}
                  error={currentErrors.invoicingCustomerId}
                  resetError={() => resetError("invoicingCustomerId")}
                />
              </div>
            )}
            {actionType === ACTIONS.CREATOR_REMARK && (
              <div className="field">
                <div style={{ paddingBottom: "20px" }}>
                  {" "}
                  <Checkbox
                    type="Checkbox"
                    name="removeCreatorRemark"
                    checked={removeCreatorRemark}
                    value={removeCreatorRemark}
                    onChange={(e) => {
                      setRemoveCreatorRemark((prev) => !prev);
                      resetError("creatorRemark");
                    }}
                  />
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      paddingLeft: "10px",
                    }}
                  >
                    Remove existing creator remark
                  </label>
                </div>
                <Input
                  editMode={editMode}
                  required={true}
                  label="Creator Remark"
                  placeholder="Creator Remark"
                  error={currentErrors.creatorRemark}
                  resetError={() => resetError("creatorRemark")}
                  value={jobModification.creatorRemark}
                  disabled={removeCreatorRemark}
                  onChange={(e) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      creatorRemark: e.target.value,
                    }));
                    resetError("creatorRemark");
                  }}
                  error={currentErrors.creatorRemark}
                />
              </div>
            )}
            {actionType === ACTIONS.OPERATION_REMARK && (
              <div className="field">
                <Input
                  editMode={editMode}
                  required={true}
                  label="Operation Remark"
                  placeholder="operation remark"
                  value={jobModification.operationRemark}
                  onChange={(e) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      operationRemark: e.target.value,
                    }));
                    resetError("operationRemark");
                  }}
                  error={currentErrors.operationRemark}
                  resetError={() => resetError("operationRemark")}
                />
              </div>
            )}
            {actionType === ACTIONS.PLANT_CHANGE && (
              <div>
                <SearchDropdown
                  editMode={editMode}
                  required={true}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Shipper",
                    param2: initialData?.customer,
                  }}
                  clearable={true}
                  field="req_plant_id"
                  label="Plant"
                  value={jobModification.plant}
                  onChange={(value) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      plant: value,
                    }));
                    resetError("plant");
                  }}
                  onClear={() => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      plant: null,
                    }));
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: jobModification?.plant?.toString(),
                  }}
                  error={currentErrors.plant}
                  resetError={() => resetError("plant")}
                  onResultSelect={(data) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      plant: data,
                    }));
                  }}
                />
              </div>
            )}
            {actionType === ACTIONS.OTHER_REQUEST && (
              <div>
                <JobOtherChange
                  editMode={editMode}
                  requestId={jobModification.requestId}
                  isOpen={isOpen}
                  otherRequests={otherRequests}
                  setOtherRequests={setOtherRequests}
                  customer={jobModification.customer}
                />
                {currentErrors.otherRequests && (
                  <div
                    className="ui error message"
                    style={{ display: "block", marginTop: "10px" }}
                  >
                    <p>{currentErrors.otherRequests}</p>
                  </div>
                )}
              </div>
            )}
            {actionType === ACTIONS.VEHICLE_CHANGES && (
              <div>
                <div className="two fields">
                  <SearchDropdown
                    editMode={editMode}
                    required={true}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Transporter",
                    }}
                    label="Transporter"
                    value={jobModification.transporter}
                    onChange={(value) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        transporter: value,
                      }));

                      resetVehicleSection();
                      resetError("vehicleChanges");
                    }}
                    onClear={() => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        transporter: null,
                      }));
                      resetVehicleSection();
                    }}
                    onResultSelect={(data) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        transporter: data,
                      }));
                      resetVehicleSection();
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_stakeholder",
                      primaryKey: "stk_id",
                      fieldName: "stk_name",
                      id: jobModification.transporter?.toString(),
                    }}
                    error={currentErrors.transporter}
                    resetError={() => resetError("transporter")}
                  />

                  <SearchDropdown
                    editMode={editMode}
                    required={true}
                    reset={vehicleReset}
                    setReset={setVehicleReset}
                    clearable={true}
                    label="Vehicle"
                    value={jobModification.vehicle}
                    onChange={(value) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        vehicle: value,
                      }));
                      resetError("vehicleChanges");
                    }}
                    onResultSelect={(data) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        vehicle: data,
                      }));
                    }}
                    onClear={() => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        vehicle: null,
                      }));
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_vehicle_details",
                      primaryKey: "veh_id",
                      fieldName: "veh_vehicleno",
                      id: jobModification.vehicle?.toString(),
                    }}
                    api={vehicleAssignmentSearch}
                    apiDependency={{
                      lTransporter:
                        jobModification.transporter !== ""
                          ? jobModification.transporter
                          : null,
                      lDriver:
                        vehicleAssignmentSearch.jobDriver !== ""
                          ? vehicleAssignmentSearch.jobDriver
                          : null,
                      lVehicleType: jobModification.vehicleType,
                      cbm: exactCbm === 1 ? -1 : -2,
                      lCommit: commitment,
                      fullObject: true,
                    }}
                    error={currentErrors.vehicle}
                    resetError={() => resetError("vehicle")}
                  />
                </div>

                <div className="two fields">
                  <SearchDropdown
                    editMode={editMode}
                    required={true}
                    reset={vehicleReset}
                    setReset={setVehicleReset}
                    clearable={true}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "employee",
                      value: "Driver",
                      param1: jobModification.transporter?.toString(),
                    }}
                    onResultSelect={(data) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        driver: data,
                      }));
                    }}
                    onClear={() => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        driver: null,
                      }));
                    }}
                    label="Driver"
                    value={jobModification.driver}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_employee",
                      primaryKey: "emp_id",
                      fieldName: "emp_fullname",
                      id: jobModification.driver?.toString(),
                    }}
                    onChange={(value) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        driver: value,
                      }));
                      resetError("vehicleChanges");
                    }}
                    error={currentErrors.driver}
                    resetError={() => resetError("driver")}
                  />

                  <SearchDropdown
                    editMode={editMode}
                    reset={vehicleReset}
                    setReset={setVehicleReset}
                    clearable={true}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "employee",
                      value: "Helper",
                      param1: jobModification.transporter?.toString(),
                    }}
                    label="Helper"
                    value={jobModification.helper}
                    onChange={(value) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        helper: value,
                      }));
                      resetError("vehicleChanges");
                    }}
                    onClear={() => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        helper: null,
                      }));
                    }}
                    onResultSelect={(data) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        helper: data,
                      }));
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_employee",
                      primaryKey: "emp_id",
                      fieldName: "emp_fullname",
                      id: jobModification.helper?.toString(),
                    }}
                    error={currentErrors.helper}
                    resetError={() => resetError("helper")}
                  />
                </div>

                <div className="two fields">
                  <SearchDropdown
                    editMode={editMode}
                    required={true}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "req_vehicle_type",
                      value: "customer_shipper",
                      param2: initialData?.customer,
                      param4: jobModification.plant?.toString(),
                    }}
                    fieldInfo={{
                      tableName: "masterdata.tms_m_vehicle_type",
                      primaryKey: "vht_id",
                      fieldName: "vht_type",
                      id: jobModification.vehicleType?.toString(),
                    }}
                    onClear={() => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        vehicleType: null,
                      }));
                    }}
                    onResultSelect={(data) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        vehicleType: data,
                      }));
                    }}
                    label="Vehicle Type"
                    value={jobModification.vehicleType}
                    onChange={(value) => {
                      setJobModification((prevState) => ({
                        ...prevState,
                        vehicleType: value,
                      }));
                      resetError("vehicleChanges");
                    }}
                    error={currentErrors.vehicleType}
                    resetError={() => resetError("vehicleType")}
                  />
                </div>

                {currentErrors.vehicleChanges && (
                  <div
                    className="ui error message"
                    style={{ display: "block" }}
                  >
                    <p>{currentErrors.vehicleChanges}</p>
                  </div>
                )}
              </div>
            )}
            {actionType === ACTIONS.REQUEST_ARRIVAL_TIME && (
              <div>
                <DateTimePickerInput
                  editMode={editMode}
                  required={true}
                  reset={searchFieldReset}
                  field="req_arrival_eta"
                  setReset={setSearchFieldReset}
                  onAccept={(value) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      arrivalTime: value,
                      arrivalTimeFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  label="Request Arrival Time"
                  value={jobModification.arrivalTime}
                  error={currentErrors.arrivalTime}
                  resetError={() => resetError("arrivalTime")}
                />
              </div>
            )}
            {actionType === ACTIONS.DELIVERY_CUTOFF_DATE && (
              <div>
                <DateTimePickerInput
                  editMode={editMode}
                  reset={searchFieldReset}
                  field="delivery_cutoff_date"
                  setReset={setSearchFieldReset}
                  value={jobModification.deliveryCutoffDate}
                  style={{
                    borderColor: currentErrors.deliveryCutoffDate ? "red" : "",
                  }}
                  onAccept={(value) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      deliveryCutoffDate: value,
                      deliveryCutoffDateFormatted: formatFromJsonDate(value),
                    }));
                  }}
                  error={currentErrors.deliveryCutoffDate}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { deliveryCutoffDate: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="Delivery Cutoff Date"
                />
              </div>
            )}

            {actionType === ACTIONS.KM_CHANGE && (
              <div className="two fields">
                <Input
                  label="Chargeable Km"
                  type="number"
                  placeholder="Chargeable Km"
                  resetError={() => resetError("chargeableKm")}
                  value={jobModification.chargeableKm}
                  onChange={(e) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      chargeableKm: e.target.value,
                    }));
                    resetError("chargeableKm");
                  }}
                  error={currentErrors.chargeableKm}
                />
                <Input
                  label="Cargo In Hand"
                  type="number"
                  placeholder="Cargo In Hand"
                  resetError={() => resetError("kmActual")}
                  value={jobModification.kmActual}
                  onChange={(e) => {
                    setJobModification((prevState) => ({
                      ...prevState,
                      kmActual: e.target.value,
                    }));
                    resetError("kmActual");
                  }}
                  error={currentErrors.kmActual}
                />
              </div>
            )}
            {currentErrors.kmChange && (
              <div className="ui error message" style={{ display: "block" }}>
                <p>{currentErrors.kmChange}</p>
              </div>
            )}

            <div className="field" style={{ marginTop: "20px" }}>
              <Input
                label="Modification Remark (Optional)"
                placeholder="Enter reason for modification"
                value={jobModification.modificationRemark}
                onChange={(e) => {
                  setJobModification((prevState) => ({
                    ...prevState,
                    modificationRemark: e.target.value,
                  }));
                }}
              />
            </div>
          </div>

          {showConfirmation && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <div
                className="ui segment"
                style={{
                  background: "#fff",
                  padding: "44px",
                  borderRadius: "8px",
                  minWidth: "320px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  textAlign: "center",
                }}
              >
                <h4 style={{ marginBottom: "8px", fontSize: "20px" }}>
                  Confirm Update
                </h4>
                <p
                  style={{
                    color: "#555",
                    marginBottom: "20px",
                    fontSize: "16px",
                  }}
                >
                  Are you sure you want to submit this job modification?
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                  }}
                >
                  <button
                    className="ui button"
                    onClick={() => setShowConfirmation(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="ui primary button"
                    onClick={handleConfirmedSubmit}
                  >
                    Yes, Update
                  </button>
                </div>
              </div>
            </div>
          )}
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                label="Update"
                onClick={handleSubmitClick}
                disabled={isSubmitting}
                loading={isSubmitting}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default JobChange;
